(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  async function addToCart(variantId, qty = 1) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    });
    // Page reload ke saath drawer open karne ka flag
    localStorage.setItem("openCartDrawer", "true");
    window.location.reload();
  }

  function bindButtons(wrapper, variantId) {
    const plusBtns = wrapper.querySelectorAll(".quick-add__plus");
    const counter = wrapper.querySelector(".quick-add__counter");
    const qtySpan = wrapper.querySelector(".quick-add__qty");
    const minusBtn = wrapper.querySelector(".quick-add__minus");
    const removeBtn = wrapper.querySelector(".quick-add__remove");
    const addBtn = wrapper.querySelector(".quick-add__add-btn");

    let quantity = 0;

    plusBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        if (quantity === 0) {
          quantity = 1;
          wrapper.querySelector(".quick-add__plus").classList.add("hidden");
          counter.classList.remove("hidden");
          qtySpan.textContent = quantity;
          minusBtn.classList.add("hidden");
          removeBtn.classList.remove("hidden");
          addBtn.classList.remove("hidden");
        } else {
          quantity++;
          qtySpan.textContent = quantity;
          minusBtn.classList.remove("hidden");
          removeBtn.classList.add("hidden");
        }
      });
    });

    minusBtn.addEventListener("click", () => {
      if (quantity > 1) {
        quantity--;
        qtySpan.textContent = quantity;
      }
      if (quantity === 1) {
        minusBtn.classList.add("hidden");
        removeBtn.classList.remove("hidden");
      }
    });

    removeBtn.addEventListener("click", () => {
      quantity = 0;
      qtySpan.textContent = 0;
      counter.classList.add("hidden");
      wrapper.querySelector(".quick-add__plus").classList.remove("hidden");
      minusBtn.classList.remove("hidden");
      removeBtn.classList.add("hidden");
      addBtn.classList.add("hidden");
    });

    addBtn.addEventListener("click", async () => {
      if (quantity > 0) {
        await addToCart(variantId, quantity);
      }
    });
  }

  // Init quick add
  document.querySelectorAll(".quick-add__actions").forEach(wrapper => {
    const form = wrapper.closest("form");
    const variantId = form.querySelector("[name='id']")?.value;
    wrapper.dataset.variantId = variantId;
    bindButtons(wrapper, variantId);
  });

  // Page reload ke baad drawer kholna (Horizon fix)
  if (localStorage.getItem("openCartDrawer") === "true") {
    localStorage.removeItem("openCartDrawer");
    setTimeout(() => {
      const dialog = document.querySelector("cart-drawer-component dialog");
      if (dialog && typeof dialog.showModal === "function" && !dialog.open) {
        dialog.showModal(); // ✅ Horizon ka drawer open karega
      }
      document.querySelector("cart-drawer-component")?.classList.add("is-open");
      document.body.classList.add("overflow-hidden");
    }, 600);
  }
});
  } catch(e) { console.error(e); }
})();

})();
